<template>
    <div>
        <h4>Nouvelle personne morale</h4>
        <b-col sm="6" class="pl-0">
            <div v-if="beforeSearch">
                <label>SIREN</label>
                <b-input
                    v-model="siren"
                    size="sm"
                    placeholder="Saisir ici le SIREN de la personne morale à importer"
                    :formatter="sirenFormatter"
                />
                <div class="mt-3">
                    <b-button
                        variant="success"
                        size="sm"
                        @click="getPappersData"
                    >
                        <i class="fas fa-search fa-fw"></i> Rechercher
                    </b-button>

                    <b-button
                        variant="secondary"
                        size="sm"
                        @click="resetStatus"
                    >
                        <i class="fas fa-times fa-fw"></i> Annuler
                    </b-button>
                </div>
            </div>
            <div v-else>
                <div v-if="pappersData === null">
                    <b-alert show variant="secondary">
                        Aucune société ne correspond au SIREN {{ siren }}
                    </b-alert>
                    <div class="mt-3">
                        <b-button
                            id="searchBtn"
                            variant="success"
                            size="sm"
                            @click="searchAgain"
                        >
                            <i class="fas fa-search fa-fw"></i> Rechercher un
                            autre SIREN
                        </b-button>

                        <b-button
                            variant="secondary"
                            size="sm"
                            @click="resetStatus"
                        >
                            <i class="fas fa-times fa-fw"></i> Annuler
                        </b-button>
                    </div>
                </div>
                <div v-else>
                    <b-input
                        v-model="form.fullname"
                        size="sm"
                        class="mb-1"
                        disabled
                    />

                    <div class="mt-3">
                        <b-button
                            id="saveBtn"
                            variant="success"
                            size="sm"
                            @click="storeMoralPerson"
                        >
                            <i class="fas fa-save fa-fw"></i> Enregistrer la
                            personne morale
                        </b-button>

                        <b-button
                            variant="secondary"
                            size="sm"
                            @click="resetStatus"
                        >
                            <i class="fas fa-times fa-fw"></i> Annuler
                        </b-button>
                    </div>
                </div>
            </div>
        </b-col>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Formatter from '../../../../common/mixins/Formatter'

export default {
    name: 'MoralPersonCreate',

    mixins: [Formatter],

    data() {
        return {
            siren: '',
            form: {},
            pappersData: {},
            beforeSearch: true,
        }
    },

    methods: {
        async getPappersData() {
            const cleanSiren = this.numericString(this.siren)
            try {
                const response = await axios.get(
                    `/moralPersons/pappers/${cleanSiren}`
                )
                this.pappersData = response.data.data
                if (this.pappersData !== null) {
                    this.initForm()
                }
                this.beforeSearch = false
            } catch (error) {
                console.error(error)
            }
        },

        initForm() {
            this.form.fullname = this.pappersData.denomination
            this.form.fullname += ` - ${this.pappersData.siege.code_postal}`
            this.form.fullname += ` ${this.pappersData.siege.ville}`
            this.form.registration_number = this.pappersData.siren
            // this.form.name = this.pappersData.denomination
            // this.form.adress_1 = this.pappersData.siege.adresse_ligne_1
            // this.form.adress_2 = this.pappersData.siege.adresse_ligne_2
            // this.form.zip_code = this.pappersData.siege.code_postal
            // this.form.city = this.pappersData.siege.ville

            // this.form.registration_city = this.pappersData.greffe
            // this.form.asset = this.pappersData.capital
        },

        searchAgain() {
            this.siren = ''
            this.beforeSearch = true
        },

        async storeMoralPerson() {
            this.form.client_id = this.client.id
            try {
                const response = await axios.post(
                    '/associates/moralPersons/new',
                    this.form
                )
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        resetStatus() {
            this.$store.commit('legalVM/RESET_STATUS')
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
        }),
    },
}
</script>

<style scoped></style>
